<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.va_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="va_vendname">
            <label class="weui-form-preview__label">{{
              customLabel.va_vendname || "供应商名称"
            }}</label>
            <em class="weui-form-preview__value">{{
              form.main.va_vendname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="va_payments">
            <label class="weui-form-preview__label">{{
              customLabel.va_payments || "付款方式"
            }}</label>
            <span class="weui-form-preview__value">
              {{ form.main.va_payments }}
              <span v-if="form.main.va_currency">{{
                form.main.va_currency
              }}</span>
              <span v-if="form.main.va_rate && form.main.va_rate != 1"
                >/ {{ form.main.va_rate }}</span
              >
            </span>
          </div>
          <div class="weui-form-preview__item" slot="va_date">
            <label class="weui-form-preview__label">{{
              customLabel.va_date || "收料日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.va_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="va_class">
            <label class="weui-form-preview__label">{{
              customLabel.va_class || "收料类型"
            }}</label>
            <em class="weui-form-preview__value">{{ form.main.va_class }}</em>
          </div>
          <div class="weui-form-preview__item" slot="va_sendcode">
            <label class="weui-form-preview__label">{{
              customLabel.va_sendcode || "送货单号"
            }}</label>
            <em class="weui-form-preview__value">{{
              form.main.va_sendcode
            }}</em>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.vad_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="vad_source_code">
              <label class="weui-form-preview__label">{{
                customLabel.vad_source_code || "来源单号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.vad_source_code
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vad_prodcode">
              <label class="weui-form-preview__label">{{
                customLabel.vad_prodcode || "物料编号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.vad_prodcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{
                customLabel.pr_detail || "物料名称"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pr_detail }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{
                customLabel.pr_orispeccode || "型号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pr_orispeccode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vad_qty">
              <label class="weui-form-preview__label">{{
                customLabel.vad_qty || "收料数量"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.vad_qty }} {{ item.pr_unit }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="qty" v-if="item.qty">
              <label class="weui-form-preview__label">{{
                customLabel.qty || "辅助数量"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.qty }} {{ item.productDTO.pr_unit_extra }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="vad_batchcode">
              <label class="weui-form-preview__label">{{
                customLabel.vad_batchcode || "批次号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.vad_batchcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vad_madetime">
              <label class="weui-form-preview__label">{{
                customLabel.vad_madetime || "生产日期"
              }}</label>
              <span class="weui-form-preview__value">{{
                dateFormat(item.vad_madetime,'yyyy-MM-dd')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vad_shelflife">
              <label class="weui-form-preview__label">{{
                customLabel.vad_shelflife || "保质期（天）"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.vad_shelflife
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vad_lifedate">
              <label class="weui-form-preview__label">{{
                customLabel.vad_lifedate || "保质期"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.vad_lifedate
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="vad_remark">
              <label class="weui-form-preview__label">{{
                customLabel.vad_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.vad_remark
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="iqc_code">
              <label class="weui-form-preview__label">{{
                customLabel.iqc_code || "检验单号"
              }}</label>
              <span class="weui-form-preview__value">{{ item.iqc_code }}</span>
            </div>
            <div class="weui-form-preview__item" slot="iqc_result">
              <label class="weui-form-preview__label">{{
                customLabel.iqc_result || "检验结果"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.iqc_result
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="iqc_okqty">
              <label class="weui-form-preview__label">{{
                customLabel.iqc_okqty || "合格数量"
              }}</label>
              <span class="weui-form-preview__value">{{ item.iqc_okqty }}</span>
            </div>
            <div class="weui-form-preview__item" slot="iqc_ngqty">
              <label class="weui-form-preview__label">{{
                customLabel.iqc_ngqty || "不合格数量"
              }}</label>
              <span class="weui-form-preview__value">{{ item.iqc_ngqty }}</span>
            </div>
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.va_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.va_auditman
            }}</span>
          </div>
        </div>
      </div>
      <file-list v-model="form.main.va_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/purchase/verify_apply_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList
  },
  data() {
    return {
      baseUrl: "/api/storage/purcverifyapply",
      xtype: "stock-purcVerifyApply-formpanel",
      caller: "PurcVerifyApply",
      codeField: "va_code",
      statusField: "va_statuscode",
    };
  },
};
</script>